// @ts-nocheck
// 该文件由 kmi 自动生成
// DO NOT CHANGE IT MANUALLY!
import '@@/core/polyfill';

import { createPluginManager } from '@@/core/plugin';


async function render() {
  const pluginManager = createPluginManager();

  // 处理部分参数需要等待 plugin 初始化的问题
  pluginManager.applyPlugins({
    type: 'event',
    key: 'onPluginCreated',
    args: {
      pluginManager,
    },
  });

  console.info('[kmi] 启用运行时插件');
}


render();


if (process.env.NODE_ENV === 'development') {
  console.log('[kmi] version 1.3.6')
}